// Environment variable access wrapper
// This module provides a consistent interface for accessing environment variables
// across different environments (Vite/Browser and Jest/Node)

// In Jest/Node environment, variables come from process.env
// In Vite/Browser environment, variables come from import.meta.env

export function getEnvVar(key: string): string | undefined {
  // Check process.env first (Jest/Node)
  if (typeof process !== 'undefined' && process.env) {
    const value = process.env[key];
    if (value) return value;
  }

  // Vite/Browser - access import.meta.env
  // Note: Vite will replace import.meta.env.* at build time
  // @ts-ignore
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env[key];
  }

  return undefined;
}
